import React from 'react';
import './Title.scss';

function Title() {
  return (
    <div className="home-page-title">
      <div className="welcome-to">Welcome to</div>
      <div className="harmony-hill">HARMONY HILL</div>
      <div className="a-primitive-baptist-foundation">
        A Primitive Baptist Foundation
      </div>
    </div>
  );
}

export default Title;
